(() => {
  var __defProp = Object.defineProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };

  // assets/skipp-location.js
  var skipp_location_exports = {};
  __export(skipp_location_exports, {
    GEO_URL_GLOBAL: () => GEO_URL_GLOBAL,
    LOCATION_COOKIE_MAX_AGE_SEC: () => LOCATION_COOKIE_MAX_AGE_SEC,
    LOCATION_COOKIE_NAME: () => LOCATION_COOKIE_NAME,
    LOCATION_STORAGE_KEY: () => LOCATION_STORAGE_KEY,
    clearUserCity: () => clearUserCity,
    detectCityFromIP: () => detectCityFromIP,
    getMockCityFromIP: () => getMockCityFromIP,
    getUserCity: () => getUserCity,
    normalizeCity: () => normalizeCity,
    setUserCity: () => setUserCity
  });
  var LOCATION_STORAGE_KEY = "skipp:userCity";
  var LOCATION_COOKIE_NAME = "skipp_user_city";
  var LOCATION_COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 180;
  var GEO_URL_GLOBAL = "__SKIPP_IP_GEO_URL__";
  var MANUAL_KEY = "manual";
  function isBrowser() {
    return typeof window !== "undefined" && typeof document !== "undefined";
  }
  function slugifyCityId(name) {
    return String(name).trim().toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/gi, "");
  }
  function normalizeCity(city) {
    if (typeof city === "string") {
      const c2 = city.trim();
      return {
        city: c2,
        cityId: slugifyCityId(c2) || "unknown",
        source: "manual",
        manual: true
      };
    }
    const c = (city.city || "").trim();
    const manual = Boolean(city.manual);
    return {
      city: c,
      cityId: city.cityId || slugifyCityId(c) || "unknown",
      source: city.source || (manual ? "manual" : "ip"),
      manual,
      mock: city.mock,
      updatedAt: city.updatedAt
    };
  }
  function toPublicCity(record) {
    return {
      city: record.city,
      cityId: record.cityId,
      source: record.source,
      manual: Boolean(record.manual),
      ...record.mock !== void 0 ? { mock: record.mock } : {},
      ...record.updatedAt ? { updatedAt: record.updatedAt } : {}
    };
  }
  function readLocalStorageEnvelope() {
    if (!isBrowser()) return null;
    try {
      const raw = window.localStorage.getItem(LOCATION_STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }
  function writeLocalStorageEnvelope(envelope) {
    if (!isBrowser()) return;
    try {
      window.localStorage.setItem(LOCATION_STORAGE_KEY, JSON.stringify(envelope));
    } catch (e) {
    }
  }
  function getEffectiveFromEnvelope(env) {
    if (!env) return null;
    if (env[MANUAL_KEY])
      return normalizeCity({ ...env[MANUAL_KEY], manual: true, source: "manual" });
    if (env.auto) return normalizeCity({ ...env.auto, manual: false });
    return null;
  }
  function syncCookieToEffective(envelope) {
    const effective = getEffectiveFromEnvelope(envelope);
    if (effective) writeCookie(effective);
  }
  function parseCookiePayload(value) {
    try {
      const decoded = decodeURIComponent(value);
      const data = JSON.parse(decoded);
      if (!data || typeof data !== "object" || typeof data.city !== "string") return null;
      return normalizeCity({ ...data, source: data.source || "cookie", manual: Boolean(data.manual) });
    } catch (e) {
      return null;
    }
  }
  function readBrowserCookieCity() {
    if (!isBrowser()) return null;
    const match = document.cookie.match(
      new RegExp(`(?:^|;\\s*)${LOCATION_COOKIE_NAME}=([^;]*)`)
    );
    if (!match) return null;
    return parseCookiePayload(match[1]);
  }
  function readCookieHeaderCity(cookieHeader) {
    if (!cookieHeader || typeof cookieHeader !== "string") return null;
    const parts = cookieHeader.split(";").map((p) => p.trim());
    for (const part of parts) {
      const eq = part.indexOf("=");
      if (eq === -1) continue;
      const k = part.slice(0, eq).trim();
      const v = part.slice(eq + 1).trim();
      if (k === LOCATION_COOKIE_NAME) return parseCookiePayload(v);
    }
    return null;
  }
  function writeCookie(city) {
    if (!isBrowser()) return;
    const payload = encodeURIComponent(
      JSON.stringify({
        city: city.city,
        cityId: city.cityId,
        source: city.source,
        manual: Boolean(city.manual),
        ...city.mock !== void 0 ? { mock: city.mock } : {},
        updatedAt: city.updatedAt
      })
    );
    document.cookie = `${LOCATION_COOKIE_NAME}=${payload}; Path=/; Max-Age=${LOCATION_COOKIE_MAX_AGE_SEC}; SameSite=Lax`;
  }
  function getUserCity(options = {}) {
    const { cookieHeader } = options;
    if (isBrowser()) {
      const env = readLocalStorageEnvelope();
      if (env == null ? void 0 : env[MANUAL_KEY]) return toPublicCity(normalizeCity({ ...env[MANUAL_KEY], manual: true, source: "manual" }));
      if (env == null ? void 0 : env.auto) return toPublicCity(normalizeCity({ ...env.auto, manual: false }));
      const fromCookie = readBrowserCookieCity();
      if (fromCookie) {
        return toPublicCity(
          normalizeCity({
            ...fromCookie,
            source: fromCookie.source === "manual" ? "manual" : "cookie",
            manual: Boolean(fromCookie.manual)
          })
        );
      }
      return null;
    }
    if (cookieHeader) {
      const fromHeader = readCookieHeaderCity(cookieHeader);
      if (fromHeader) return toPublicCity(normalizeCity({ ...fromHeader, manual: Boolean(fromHeader.manual) }));
    }
    return null;
  }
  function setUserCity(city, options = {}) {
    const manual = Boolean(options.manual);
    const base = typeof city === "string" ? manual ? normalizeCity(city) : normalizeCity({ city, manual: false, source: "ip" }) : normalizeCity({ ...city, manual });
    const record = {
      ...base,
      manual,
      source: manual ? "manual" : base.source || "ip",
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    };
    if (!isBrowser()) return;
    const prev = readLocalStorageEnvelope() || {};
    const next = { ...prev };
    if (manual) {
      next[MANUAL_KEY] = { ...record, source: "manual", manual: true };
    } else {
      next.auto = { ...record, manual: false };
    }
    writeLocalStorageEnvelope(next);
    syncCookieToEffective(next);
    emitCityChanged();
  }
  function clearUserCity() {
    if (!isBrowser()) return;
    try {
      window.localStorage.removeItem(LOCATION_STORAGE_KEY);
    } catch (e) {
    }
    document.cookie = `${LOCATION_COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
    emitCityChanged();
  }
  function emitCityChanged() {
    if (!isBrowser()) return;
    try {
      document.dispatchEvent(new CustomEvent("skipp:city-changed", { detail: getUserCity() }));
    } catch (e) {
    }
  }
  function mapGeoResponse(json) {
    if (!json || typeof json !== "object") return null;
    const cityName = typeof json.city === "string" ? json.city.trim() : "";
    if (!cityName) return null;
    const fromApiId = typeof json.cityId === "string" ? json.cityId : json.region ? `${json.countryCode || ""}-${json.region}-${json.city}`.toLowerCase().replace(/\s+/g, "-") : void 0;
    return normalizeCity({
      city: cityName,
      cityId: fromApiId,
      source: "ip",
      manual: false,
      mock: false
    });
  }
  function getMockCityFromIP() {
    return normalizeCity({
      city: "Bengaluru",
      cityId: "in-ka-bengaluru",
      source: "mock",
      manual: false,
      mock: true
    });
  }
  async function detectCityFromIP() {
    const geoUrl = isBrowser() && window[GEO_URL_GLOBAL] && typeof window[GEO_URL_GLOBAL] === "string" ? window[GEO_URL_GLOBAL] : null;
    if (!geoUrl) {
      return { ...getMockCityFromIP(), updatedAt: (/* @__PURE__ */ new Date()).toISOString() };
    }
    try {
      const res = await fetch(geoUrl, { credentials: "omit", cache: "no-store" });
      if (!res.ok) throw new Error(`GEO_HTTP_${res.status}`);
      const json = await res.json();
      const mapped = mapGeoResponse(json);
      if (mapped) {
        return { ...mapped, updatedAt: (/* @__PURE__ */ new Date()).toISOString() };
      }
    } catch (e) {
    }
    return { ...getMockCityFromIP(), updatedAt: (/* @__PURE__ */ new Date()).toISOString() };
  }

  // assets/skipp-user-location.js
  var skipp_user_location_exports = {};
  __export(skipp_user_location_exports, {
    DEVICE_GEO_KEY: () => DEVICE_GEO_KEY,
    USER_CITY_SIMPLE_COOKIE: () => USER_CITY_SIMPLE_COOKIE,
    USER_LOCATION_PLAIN_KEY: () => USER_LOCATION_PLAIN_KEY,
    USER_LOC_COOKIE_NAME: () => USER_LOC_COOKIE_NAME,
    USER_LOC_STORAGE_KEY: () => USER_LOC_STORAGE_KEY,
    browsingLocationTeaser: () => browsingLocationTeaser,
    cleanText: () => cleanText,
    clearDeliverableUserLocation: () => clearDeliverableUserLocation,
    getCityDisplayLabel: () => getCityDisplayLabel,
    getCityFromPincode: () => getCityFromPincode,
    getDeliveryTimeLabel: () => getDeliveryTimeLabel,
    getDeviceCoords: () => getDeviceCoords,
    getDistanceKmIfAvailable: () => getDistanceKmIfAvailable,
    getUserLocation: () => getUserLocation,
    getUserLocationPlain: () => getUserLocationPlain,
    haversineKm: () => haversineKm,
    isExpressDeliveryCity: () => isExpressDeliveryCity,
    normalizeEtaFragment: () => normalizeEtaFragment,
    promptBrowserGeolocationAndApplyLocation: () => promptBrowserGeolocationAndApplyLocation,
    setDeviceCoords: () => setDeviceCoords,
    setUserLocation: () => setUserLocation,
    setUserLocationFromIP: () => setUserLocationFromIP,
    slugId: () => slugId
  });

  // assets/skipp-location-utils.js
  function cleanText(text) {
    return String(text || "").replace(/[^\x00-\x7F]/g, "").trim();
  }
  function getCityFromPincode(pincode) {
    const pc = String(pincode || "").replace(/\D/g, "");
    if (!pc) return null;
    if (pc.startsWith("56")) return "bangalore";
    if (pc.startsWith("400")) return "mumbai";
    return null;
  }

  // assets/skipp-user-location.js
  var USER_LOC_STORAGE_KEY = "skipp:userLocationV2";
  var USER_LOC_COOKIE_NAME = "skipp_user_location_v2";
  var USER_LOCATION_PLAIN_KEY = "user_location";
  var USER_CITY_SIMPLE_COOKIE = "user_city";
  var DEVICE_GEO_KEY = "skipp:deviceGeo";
  var MANUAL = "manual";
  function isBrowser2() {
    return typeof window !== "undefined" && typeof document !== "undefined";
  }
  function slugId(name) {
    return String(name || "").trim().toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/gi, "");
  }
  function getCityDisplayLabel(city) {
    if (!city) return "";
    const k = String(city).toLowerCase().trim();
    if (k === "bangalore") return "Bengaluru";
    if (k === "mumbai") return "Mumbai";
    return String(city).trim();
  }
  function isExpressDeliveryCity(city) {
    if (!city || typeof city !== "string") return false;
    const slug = slugId(city);
    if (!slug) return false;
    if (slug.includes("bengaluru") || slug.includes("bangalore")) return true;
    if (slug.includes("mumbai") || slug.includes("bombay")) return true;
    return false;
  }
  function getDeliveryTimeLabel(city, expressLabel, nextDayLabel) {
    const ex = (expressLabel != null && String(expressLabel).trim() || "30 - 90 mins").trim() || "30 - 90 mins";
    const nd = (nextDayLabel != null && String(nextDayLabel).trim() || "Next day delivery").trim() || "Next day delivery";
    if (!city || !String(city).trim()) return "";
    return isExpressDeliveryCity(city) ? ex : nd;
  }
  function normalizeEtaFragment(raw) {
    let t = String(raw || "").trim().replace(/\u00a0/g, " ");
    if (!t) return "30 - 90 mins";
    while (/^delivery\s+in\s+/i.test(t)) {
      t = t.replace(/^delivery\s+in\s+/i, "").trim();
    }
    return t || "30 - 90 mins";
  }
  function browsingLocationTeaser(_expressLabel) {
    void _expressLabel;
    return "Set your area \xB7 tap to choose delivery location";
  }
  async function reverseNominatimLatLng(lat, lng) {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lng)}&accept-language=en&addressdetails=1`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("NOMINATIM");
    const data = await res.json();
    const addr = data.address || {};
    const city = addr.city || addr.town || addr.village || addr.suburb || addr.county || addr.state || "Unknown";
    const postcode = addr.postcode ? String(addr.postcode).trim() : null;
    return {
      city: String(city),
      label: data.display_name || city,
      postcode
    };
  }
  async function promptBrowserGeolocationAndApplyLocation(opts = {}) {
    if (!isBrowser2()) return { ok: false, reason: "no-browser" };
    if (typeof globalThis.isSecureContext !== "undefined" && !globalThis.isSecureContext) {
      return { ok: false, reason: "insecure" };
    }
    if (!navigator.geolocation) return { ok: false, reason: "unsupported" };
    const env = readEnvelope();
    if (!opts.force && (env == null ? void 0 : env[MANUAL])) return { ok: false, reason: "manual-pinned" };
    const express = opts.expressDeliveryText || "30 - 90 mins";
    const nextDay = opts.nextDayDeliveryText || "Next day delivery";
    let pos;
    try {
      pos = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 15e3,
          maximumAge: 0
        });
      });
    } catch (err) {
      const code = err && typeof err.code === "number" ? err.code : null;
      return {
        ok: false,
        reason: code === 1 ? "denied" : "unavailable",
        error: err
      };
    }
    const lat = pos.coords.latitude;
    const lng = pos.coords.longitude;
    let rev;
    try {
      rev = await reverseNominatimLatLng(lat, lng);
    } catch (e) {
      return { ok: false, reason: "geocode" };
    }
    setDeviceCoords(lat, lng);
    setUserLocation(
      {
        city: rev.city,
        lat,
        lng,
        label: rev.label,
        pincode: rev.postcode,
        deliveryTime: getDeliveryTimeLabel(rev.city, express, nextDay)
      },
      { manual: false, source: "gps", updateDevice: true }
    );
    return { ok: true };
  }
  function haversineKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return Math.round(R * c * 10) / 10;
  }
  function readEnvelope() {
    if (!isBrowser2()) return null;
    try {
      const raw = localStorage.getItem(USER_LOC_STORAGE_KEY);
      if (!raw) return null;
      const p = JSON.parse(raw);
      return p && typeof p === "object" ? p : null;
    } catch (e) {
      return null;
    }
  }
  function writeEnvelope(env) {
    if (!isBrowser2()) return;
    try {
      localStorage.setItem(USER_LOC_STORAGE_KEY, JSON.stringify(env));
    } catch (e) {
    }
  }
  function getEffectiveRecord(env) {
    if (!env) return null;
    if (env[MANUAL]) return { ...env[MANUAL], _slot: MANUAL };
    if (env.auto) return { ...env.auto, _slot: "auto" };
    return null;
  }
  function stripSlot(rec) {
    if (!rec) return null;
    const { _slot, ...rest } = rec;
    return rest;
  }
  function writeUserLocCookie(record) {
    if (!isBrowser2() || !(record == null ? void 0 : record.city)) return;
    const payload = encodeURIComponent(
      JSON.stringify({
        city: record.city,
        lat: record.lat,
        lng: record.lng,
        label: record.label || record.city,
        source: record.source,
        updatedAt: record.updatedAt,
        pincode: record.pincode || null,
        deliveryTime: record.deliveryTime || null,
        name: record.name || null,
        fullAddress: record.fullAddress || null
      })
    );
    document.cookie = `${USER_LOC_COOKIE_NAME}=${payload}; Path=/; Max-Age=${LOCATION_COOKIE_MAX_AGE_SEC}; SameSite=Lax`;
  }
  function readUserLocCookie() {
    if (!isBrowser2()) return null;
    const match = document.cookie.match(
      new RegExp(`(?:^|;\\s*)${USER_LOC_COOKIE_NAME}=([^;]*)`)
    );
    if (!match) return null;
    try {
      const data = JSON.parse(decodeURIComponent(match[1]));
      if (!data || typeof data !== "object" || typeof data.city !== "string") return null;
      return data;
    } catch (e) {
      return null;
    }
  }
  function readPlainUserLocationLocalStorage() {
    if (!isBrowser2()) return null;
    try {
      const raw = localStorage.getItem(USER_LOCATION_PLAIN_KEY);
      if (!raw) return null;
      const p = JSON.parse(raw);
      if (!p || typeof p !== "object") return null;
      const city = String(p.city || "").trim();
      if (!city) return null;
      const latN = p.lat != null ? Number(p.lat) : null;
      const lngN = p.lng != null ? Number(p.lng) : null;
      const fullAddr = String(p.full_address || p.fullAddress || "").trim();
      const pinRaw = p.pincode != null ? String(p.pincode).replace(/\D/g, "").slice(0, 6) : "";
      return {
        city,
        lat: Number.isFinite(latN) ? latN : null,
        lng: Number.isFinite(lngN) ? lngN : null,
        label: fullAddr || city,
        source: "plain-localstorage",
        pincode: pinRaw || null,
        deliveryTime: null,
        name: null,
        fullAddress: fullAddr || null
      };
    } catch (e) {
      return null;
    }
  }
  function writePlainUserLocation(record) {
    if (!isBrowser2() || !(record == null ? void 0 : record.city)) return;
    try {
      localStorage.setItem(
        USER_LOCATION_PLAIN_KEY,
        JSON.stringify({
          city: record.city,
          lat: record.lat != null && Number.isFinite(Number(record.lat)) ? Number(record.lat) : null,
          lng: record.lng != null && Number.isFinite(Number(record.lng)) ? Number(record.lng) : null,
          pincode: record.pincode || null,
          full_address: record.fullAddress || record.label || ""
        })
      );
    } catch (e) {
    }
  }
  function writeSimpleUserCityCookie(city) {
    if (!isBrowser2() || !city) return;
    try {
      document.cookie = `${USER_CITY_SIMPLE_COOKIE}=${encodeURIComponent(String(city).trim())}; Path=/; Max-Age=${LOCATION_COOKIE_MAX_AGE_SEC}; SameSite=Lax`;
    } catch (e) {
    }
  }
  function getUserLocationPlain() {
    try {
      const data = localStorage.getItem(USER_LOCATION_PLAIN_KEY);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      return null;
    }
  }
  function syncLegacyCartLocation(record) {
    if (!isBrowser2()) return;
    const legacy = {
      address: record.fullAddress || record.label || record.city,
      cityName: record.city,
      pincode: record.pincode || null,
      coordinates: record.lat != null && record.lng != null ? { latitude: record.lat, longitude: record.lng } : null,
      deliveryTime: record.deliveryTime || "30 - 90 mins"
    };
    try {
      localStorage.setItem("userLocation", JSON.stringify(legacy));
    } catch (e) {
    }
    try {
      document.dispatchEvent(
        new CustomEvent("locationUpdated", {
          detail: {
            location: {
              address: legacy.address,
              cityName: legacy.cityName,
              pincode: legacy.pincode,
              coordinates: legacy.coordinates
            },
            deliveryTime: legacy.deliveryTime,
            isAvailable: true
          }
        })
      );
    } catch (e) {
    }
  }
  function emitUserLocationChanged() {
    if (!isBrowser2()) return;
    try {
      document.dispatchEvent(
        new CustomEvent("skipp:user-location-changed", { detail: getUserLocation() })
      );
    } catch (e) {
    }
  }
  function getDeviceCoords() {
    if (!isBrowser2()) return null;
    try {
      const raw = localStorage.getItem(DEVICE_GEO_KEY);
      if (!raw) return null;
      const d = JSON.parse(raw);
      if (typeof d.lat !== "number" || typeof d.lng !== "number") return null;
      return { lat: d.lat, lng: d.lng };
    } catch (e) {
      return null;
    }
  }
  function setDeviceCoords(lat, lng) {
    if (!isBrowser2()) return;
    try {
      localStorage.setItem(
        DEVICE_GEO_KEY,
        JSON.stringify({
          lat: Number(lat),
          lng: Number(lng),
          updatedAt: (/* @__PURE__ */ new Date()).toISOString()
        })
      );
    } catch (e) {
    }
  }
  function getDistanceKmIfAvailable() {
    const dev = getDeviceCoords();
    const sel = getUserLocation();
    if (!dev || sel.lat == null || sel.lng == null) return null;
    return haversineKm(dev.lat, dev.lng, sel.lat, sel.lng);
  }
  function getUserLocation() {
    if (!isBrowser2()) {
      return {
        city: null,
        lat: null,
        lng: null,
        label: null,
        source: null,
        pincode: null,
        deliveryTime: null,
        name: null,
        fullAddress: null
      };
    }
    const env = readEnvelope();
    let rec = getEffectiveRecord(env);
    if (!rec) {
      const ck = readUserLocCookie();
      if (ck && ck.city) {
        rec = {
          city: ck.city,
          lat: ck.lat != null ? Number(ck.lat) : null,
          lng: ck.lng != null ? Number(ck.lng) : null,
          label: ck.label || ck.city,
          source: ck.source || "cookie",
          pincode: ck.pincode || null,
          deliveryTime: ck.deliveryTime || null,
          name: ck.name || null,
          fullAddress: ck.fullAddress || null
        };
      }
    }
    if (!rec) {
      rec = readPlainUserLocationLocalStorage();
    }
    if (!rec) {
      return {
        city: null,
        lat: null,
        lng: null,
        label: null,
        source: null,
        pincode: null,
        deliveryTime: null,
        name: null,
        fullAddress: null
      };
    }
    return {
      city: rec.city || null,
      lat: rec.lat != null ? Number(rec.lat) : null,
      lng: rec.lng != null ? Number(rec.lng) : null,
      label: rec.label || rec.city || null,
      source: rec.source || null,
      pincode: rec.pincode ? String(rec.pincode).trim() || null : null,
      deliveryTime: rec.deliveryTime ? String(rec.deliveryTime).trim() || null : null,
      name: rec.name ? String(rec.name).trim() || null : null,
      fullAddress: rec.fullAddress ? String(rec.fullAddress).trim() || null : null
    };
  }
  function clearDeliverableUserLocation() {
    if (!isBrowser2()) return;
    try {
      localStorage.removeItem(USER_LOC_STORAGE_KEY);
      localStorage.removeItem(USER_LOCATION_PLAIN_KEY);
      localStorage.removeItem("userLocation");
    } catch (e) {
    }
    try {
      document.cookie = `${USER_LOC_COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
      document.cookie = `${USER_CITY_SIMPLE_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
    } catch (e) {
    }
    clearUserCity();
    emitUserLocationChanged();
  }
  function setUserLocation(payload, options = {}) {
    const manual = Boolean(options.manual);
    const source = options.source || (manual ? "manual" : payload.source || "gps");
    const city = String(payload.city || "").trim();
    if (!city) return;
    const lat = payload.lat != null ? Number(payload.lat) : null;
    const lng = payload.lng != null ? Number(payload.lng) : null;
    const label = (payload.label || city).trim();
    const pincodeRaw = payload.pincode != null ? String(payload.pincode).replace(/\D/g, "").slice(0, 6) : "";
    const deliveryRaw = payload.deliveryTime != null ? String(payload.deliveryTime).trim() : "";
    const nameRaw = payload.name != null ? String(payload.name).trim() : "";
    const fullAddrRaw = payload.full_address != null ? String(payload.full_address).trim() : payload.fullAddress != null ? String(payload.fullAddress).trim() : "";
    const record = {
      city,
      lat: Number.isFinite(lat) ? lat : null,
      lng: Number.isFinite(lng) ? lng : null,
      label,
      source,
      updatedAt: (/* @__PURE__ */ new Date()).toISOString(),
      pincode: pincodeRaw || null,
      deliveryTime: deliveryRaw || null,
      name: nameRaw || null,
      fullAddress: fullAddrRaw || null
    };
    if (!isBrowser2()) return;
    if (options.updateDevice && record.lat != null && record.lng != null) {
      setDeviceCoords(record.lat, record.lng);
    }
    const prev = readEnvelope() || {};
    const next = { ...prev };
    if (!manual) {
      delete next[MANUAL];
    }
    if (manual) {
      next[MANUAL] = { ...record, source: "manual" };
    } else {
      next.auto = { ...record, source };
    }
    writeEnvelope(next);
    const eff = stripSlot(getEffectiveRecord(next));
    writeUserLocCookie(eff);
    writePlainUserLocation(record);
    writeSimpleUserCityCookie(record.city);
    setUserCity(
      {
        city,
        cityId: slugId(city),
        source: manual ? "manual" : source
      },
      { manual }
    );
    syncLegacyCartLocation(record);
    emitUserLocationChanged();
  }
  async function setUserLocationFromIP(opts = {}) {
    const ip = await detectCityFromIP();
    const express = opts.expressDeliveryText || "30 - 90 mins";
    const nextDay = opts.nextDayDeliveryText || "Next day delivery";
    const dt = getDeliveryTimeLabel(ip.city, express, nextDay);
    setUserLocation(
      {
        city: ip.city,
        lat: null,
        lng: null,
        label: ip.city,
        pincode: null,
        deliveryTime: dt
      },
      { manual: false, source: "ip" }
    );
  }

  // assets/skipp-location-global.js
  window.SkippLocation = skipp_location_exports;
  window.SkippUserLocation = skipp_user_location_exports;
  try {
    document.dispatchEvent(new CustomEvent("skipp:location-api-ready"));
  } catch (e) {
  }

  // assets/skipp-location-preference.js
  var LS_LOCATION_SET = "location_set";
  var LS_LOCATION_SKIPPED = "location_skipped";
  var LS_LOCATION_POPUP_SEEN = "location_popup_seen";
  var LS_HOME_LOCATION_PROMPT_SHOWN = "skipp_location_home_prompt_shown";
  var LS_BROWSER_GEO_AUTO = "skipp_browser_geo_auto_attempted";
  function getLocationSetPreference() {
    try {
      return localStorage.getItem(LS_LOCATION_SET);
    } catch (e) {
      return null;
    }
  }
  function markLocationConfirmed() {
    try {
      localStorage.setItem(LS_LOCATION_SET, "true");
      localStorage.setItem(LS_LOCATION_SKIPPED, "false");
    } catch (e) {
    }
    try {
      document.dispatchEvent(new CustomEvent("skipp:location-preference-changed"));
    } catch (e) {
    }
  }
  function markLocationSkipped() {
    try {
      localStorage.setItem(LS_LOCATION_SET, "false");
      localStorage.setItem(LS_LOCATION_SKIPPED, "true");
      localStorage.setItem(LS_LOCATION_POPUP_SEEN, String(Date.now()));
    } catch (e) {
    }
    try {
      document.dispatchEvent(new CustomEvent("skipp:location-preference-changed"));
    } catch (e) {
    }
  }
  function isLocationEnforcementSatisfied() {
    return getLocationSetPreference() === "true";
  }
  function hasBrowserGeoAutoBeenAttempted() {
    try {
      return localStorage.getItem(LS_BROWSER_GEO_AUTO) === "1";
    } catch (e) {
      return true;
    }
  }
  function markBrowserGeoAutoAttempted() {
    try {
      localStorage.setItem(LS_BROWSER_GEO_AUTO, "1");
    } catch (e) {
    }
  }
  function hasHomeLocationPromptBeenShown() {
    try {
      return localStorage.getItem(LS_HOME_LOCATION_PROMPT_SHOWN) === "1";
    } catch (e) {
      return true;
    }
  }
  function markHomeLocationPromptShown() {
    try {
      localStorage.setItem(LS_HOME_LOCATION_PROMPT_SHOWN, "1");
    } catch (e) {
    }
  }

  // assets/skipp-places-autocomplete.js
  var mapsLoadPromise = null;
  function loadGoogleMapsPlacesApi(apiKey) {
    var _a, _b;
    if (!apiKey) return Promise.reject(new Error("NO_KEY"));
    if ((_b = (_a = window.google) == null ? void 0 : _a.maps) == null ? void 0 : _b.places) return Promise.resolve(window.google.maps);
    if (mapsLoadPromise) return mapsLoadPromise;
    mapsLoadPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places&loading=async&language=en&region=IN`;
      s.async = true;
      s.defer = true;
      s.onload = () => resolve(window.google.maps);
      s.onerror = () => {
        mapsLoadPromise = null;
        reject(new Error("MAPS_LOAD"));
      };
      document.head.appendChild(s);
    });
    return mapsLoadPromise;
  }
  function debounce(fn, ms) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), ms);
    };
  }
  function escapeHtml(s) {
    const d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }
  function refineSuggestionSecondary(primary, secondary) {
    if (!secondary) return "";
    const sec = String(secondary).trim();
    const pri = String(primary || "").trim();
    if (!pri) return sec;
    const low = sec.toLowerCase();
    const pLow = pri.toLowerCase();
    if (low === pLow) return "";
    if (low.startsWith(`${pLow},`)) return sec.slice(pri.length + 1).trim();
    if (low.startsWith(`${pLow} -`)) return sec.slice(pri.length + 1).trim().replace(/^-\s*/, "");
    return sec;
  }
  function compLine(comp) {
    if (!comp) return "";
    return cleanText(comp.long_name) || cleanText(comp.short_name) || "";
  }
  function cityFromFormattedParts(parts) {
    if (!parts.length) return "";
    const tryIdx = [parts.length - 3, parts.length - 2, parts.length - 4, 0];
    for (const i of tryIdx) {
      if (i >= 0 && i < parts.length) {
        const c = cleanText(parts[i]);
        if (c) return c;
      }
    }
    return "";
  }
  function extractCityFromPlace(place) {
    const components = place == null ? void 0 : place.address_components;
    const formattedAddress = (place == null ? void 0 : place.formatted_address) || "";
    const placeName = (place == null ? void 0 : place.name) || "";
    const pick = (typePred) => {
      if (!(components == null ? void 0 : components.length)) return null;
      return components.find((c) => {
        var _a;
        return (_a = c.types) == null ? void 0 : _a.some((t) => typePred(t));
      }) || null;
    };
    const locality = pick((t) => t === "locality");
    const fromLoc = compLine(locality);
    if (fromLoc) return fromLoc;
    const admin2 = pick((t) => t === "administrative_area_level_2");
    const fromA2 = compLine(admin2);
    if (fromA2) return fromA2;
    const postalTown = pick((t) => t === "postal_town");
    if (compLine(postalTown)) return compLine(postalTown);
    const subloc = pick((t) => t === "sublocality_level_1" || t === "sublocality");
    if (compLine(subloc)) return compLine(subloc);
    const admin3 = pick((t) => t === "administrative_area_level_3");
    if (compLine(admin3)) return compLine(admin3);
    const pName = cleanText(placeName);
    if (pName && formattedAddress && !formattedAddress.toLowerCase().startsWith(placeName.toLowerCase())) {
      return pName;
    }
    const parts = formattedAddress.split(",").map((p) => p.trim()).filter(Boolean);
    const fromFmt = cityFromFormattedParts(parts);
    if (fromFmt) return fromFmt;
    return pName || "";
  }
  function placeDetailsToSelection(place, fallbackPrimary = "") {
    var _a, _b;
    const pincodeComp = (_a = place == null ? void 0 : place.address_components) == null ? void 0 : _a.find((c) => {
      var _a2;
      return (_a2 = c.types) == null ? void 0 : _a2.includes("postal_code");
    });
    const pincodeDigits = String((pincodeComp == null ? void 0 : pincodeComp.long_name) || (pincodeComp == null ? void 0 : pincodeComp.short_name) || "").replace(/\D/g, "");
    const pincode = pincodeDigits || null;
    const selectedCity = extractCityFromPlace(place) || cleanText(String(fallbackPrimary || "").trim()) || "";
    const derivedCity = getCityFromPincode(pincode);
    const city = (derivedCity || selectedCity || "").trim();
    const name = cleanText(place == null ? void 0 : place.name) || null;
    const full_address = cleanText(place == null ? void 0 : place.formatted_address) || "";
    let lat = null;
    let lng = null;
    if ((_b = place == null ? void 0 : place.geometry) == null ? void 0 : _b.location) {
      lat = place.geometry.location.lat();
      lng = place.geometry.location.lng();
    }
    return {
      name,
      full_address,
      city,
      lat,
      lng,
      pincode,
      selectedCity,
      derivedCity
    };
  }
  function placesPredictionToItem(p) {
    var _a, _b, _c, _d;
    const description = (p.description || "").trim();
    const mainFromStruct = (((_a = p.structured_formatting) == null ? void 0 : _a.main_text) || "").trim();
    let primaryRaw = mainFromStruct || ((_b = description.split(",")[0]) == null ? void 0 : _b.trim()) || description;
    const rawSec = ((_c = p.structured_formatting) == null ? void 0 : _c.secondary_text) || "";
    let secondaryRaw = refineSuggestionSecondary(primaryRaw, rawSec);
    if (!secondaryRaw && description && primaryRaw) {
      const dLow = description.toLowerCase();
      const pLow = primaryRaw.toLowerCase();
      if (dLow.startsWith(`${pLow},`)) secondaryRaw = description.slice(primaryRaw.length + 1).trim();
      else if (dLow.startsWith(`${pLow} -`))
        secondaryRaw = description.slice(primaryRaw.length + 1).trim().replace(/^-\s*/, "");
      else if (description !== primaryRaw) secondaryRaw = description;
    }
    let primary = cleanText(primaryRaw);
    let secondary = cleanText(secondaryRaw);
    if (!primary) {
      const fromSec = ((_d = secondary.split(",")[0]) == null ? void 0 : _d.trim()) || secondary;
      primary = cleanText(fromSec) || fromSec || "Location";
    }
    if (!secondary) {
      const dClean = cleanText(description);
      if (dClean && dClean.toLowerCase() !== primary.toLowerCase()) secondary = dClean;
    }
    if (secondary && primary && secondary.toLowerCase().startsWith(`${primary.toLowerCase()},`)) {
      secondary = secondary.slice(primary.length + 1).trim();
    }
    return {
      primary,
      secondary,
      placeId: p.place_id
    };
  }
  var SkippPlacesAutocomplete = class {
    /**
     * @param {object} opts
     * @param {string} opts.apiKey
     * @param {HTMLInputElement} opts.input
     * @param {HTMLElement} opts.listContainer - e.g. <ul>
     * @param {number} [opts.debounceMs=300]
     * @param {number} [opts.minChars=2]
     * @param {string} [opts.country='in'] - ISO country for componentRestrictions
     * @param {string} [opts.listVisibleClass='is-visible'] - added when suggestions exist
     * @param {(items: PlaceSuggestion[]) => void} [opts.onSuggestions] - optional hook
     * @param {(item: PlaceSuggestion) => void} opts.onSelect
     * @param {(q: string) => Promise<PlaceSuggestion[]>} [opts.fallbackSearch] - OSM etc.
     */
    constructor(opts) {
      var _a, _b, _c, _d;
      this.apiKey = opts.apiKey;
      this.input = opts.input;
      this.list = opts.listContainer;
      this.debounceMs = (_a = opts.debounceMs) != null ? _a : 300;
      this.minChars = (_b = opts.minChars) != null ? _b : 2;
      this.country = (_c = opts.country) != null ? _c : "in";
      this.listVisibleClass = (_d = opts.listVisibleClass) != null ? _d : "is-visible";
      this.onSuggestions = opts.onSuggestions;
      this.onSelect = opts.onSelect;
      this.fallbackSearch = opts.fallbackSearch;
      this._predictions = [];
      this._activeIndex = -1;
      this._requestGen = 0;
      this._ac = null;
      this._places = null;
      this._session = null;
      this._debouncedFetch = debounce(() => this._runFetch(), this.debounceMs);
      this._onInput = () => this._debouncedFetch();
      this._onKeydown = (e) => this._handleKeydown(e);
      this._onDocClick = (e) => {
        if (!this.list || !this.input) return;
        if (e.target === this.input || this.list.contains(e.target)) return;
        this.closeDropdown();
      };
      this.input.addEventListener("input", this._onInput);
      this.input.addEventListener("keydown", this._onKeydown);
      document.addEventListener("click", this._onDocClick, true);
    }
    /** New session after a place is resolved (billing best practice). */
    refreshSession() {
      var _a, _b;
      if ((_b = (_a = window.google) == null ? void 0 : _a.maps) == null ? void 0 : _b.places) {
        this._session = new google.maps.places.AutocompleteSessionToken();
      } else {
        this._session = null;
      }
    }
    _runFetch() {
      const q = (this.input.value || "").trim();
      if (q.length < this.minChars) {
        this._render([]);
        return;
      }
      const gen = ++this._requestGen;
      if (!this.apiKey) {
        this._tryFallback(q, gen);
        return;
      }
      loadGoogleMapsPlacesApi(this.apiKey).then(() => {
        if (gen !== this._requestGen) return;
        if (!this._ac) {
          this._ac = new google.maps.places.AutocompleteService();
        }
        if (!this._places) {
          this._places = new google.maps.places.PlacesService(document.createElement("div"));
        }
        if (!this._session) {
          this.refreshSession();
        }
        this._ac.getPlacePredictions(
          {
            input: q,
            sessionToken: this._session,
            componentRestrictions: { country: this.country }
          },
          (res, status) => {
            var _a, _b, _c;
            if (gen !== this._requestGen) return;
            const ok = status === "OK" || status === ((_c = (_b = (_a = google == null ? void 0 : google.maps) == null ? void 0 : _a.places) == null ? void 0 : _b.PlacesServiceStatus) == null ? void 0 : _c.OK);
            if (ok && Array.isArray(res) && res.length) {
              const items = res.map((p) => placesPredictionToItem(p));
              this._render(items);
              return;
            }
            this._tryFallback(q, gen);
          }
        );
      }).catch(() => {
        if (gen !== this._requestGen) return;
        this._tryFallback(q, gen);
      });
    }
    async _tryFallback(q, gen) {
      if (!this.fallbackSearch) {
        this._render([]);
        return;
      }
      try {
        const items = await this.fallbackSearch(q);
        if (gen !== this._requestGen) return;
        this._render(Array.isArray(items) ? items : []);
      } catch (e) {
        if (gen === this._requestGen) this._render([]);
      }
    }
    /**
     * @param {PlaceSuggestion[]} items
     */
    _render(items) {
      var _a, _b;
      this._predictions = items;
      this._activeIndex = -1;
      if (!this.list) return;
      this.list.innerHTML = "";
      if (!items.length) {
        this.list.classList.remove(this.listVisibleClass);
        (_a = this.onSuggestions) == null ? void 0 : _a.call(this, []);
        return;
      }
      items.forEach((item, i) => {
        var _a2, _b2;
        const li = document.createElement("li");
        li.setAttribute("role", "option");
        const title = item.primary || ((_b2 = (_a2 = item.secondary) == null ? void 0 : _a2.split(",")[0]) == null ? void 0 : _b2.trim()) || "Location";
        const sub = item.secondary ? `<span class="skipp-loc-suggest__sub">${escapeHtml(item.secondary)}</span>` : "";
        li.innerHTML = `<span class="skipp-loc-suggest__title">${escapeHtml(title)}</span>${sub}`;
        li.addEventListener("mousedown", (e) => {
          e.preventDefault();
          this._pick(item);
        });
        this.list.appendChild(li);
      });
      this.list.classList.add(this.listVisibleClass);
      (_b = this.onSuggestions) == null ? void 0 : _b.call(this, items);
    }
    _highlight() {
      if (!this.list) return;
      [...this.list.querySelectorAll("li")].forEach((li, i) => {
        li.classList.toggle("is-active", i === this._activeIndex);
      });
    }
    _handleKeydown(e) {
      var _a;
      if (!((_a = this.list) == null ? void 0 : _a.classList.contains(this.listVisibleClass)) || !this._predictions.length) {
        return;
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        this._activeIndex = Math.min(this._activeIndex + 1, this._predictions.length - 1);
        this._highlight();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        this._activeIndex = Math.max(this._activeIndex - 1, 0);
        this._highlight();
      } else if (e.key === "Enter") {
        e.preventDefault();
        const item = this._predictions[this._activeIndex >= 0 ? this._activeIndex : 0];
        this._pick(item);
      } else if (e.key === "Escape") {
        this.closeDropdown();
      }
    }
    _pick(item) {
      var _a;
      if (!item) return;
      (_a = this.onSelect) == null ? void 0 : _a.call(this, item);
    }
    closeDropdown() {
      var _a;
      this._requestGen++;
      if (this.list) {
        this.list.innerHTML = "";
        this.list.classList.remove(this.listVisibleClass);
      }
      this._predictions = [];
      this._activeIndex = -1;
      (_a = this.onSuggestions) == null ? void 0 : _a.call(this, []);
    }
    /**
     * Resolve placeId to geometry (minimal fields).
     * @param {string} placeId
     * @param {(place: google.maps.places.PlaceResult | null, status: string) => void} callback
     */
    getPlaceDetails(placeId, callback) {
      loadGoogleMapsPlacesApi(this.apiKey).then(() => {
        if (!this._places) {
          this._places = new google.maps.places.PlacesService(document.createElement("div"));
        }
        if (!this._session) {
          this.refreshSession();
        }
        this._places.getDetails(
          {
            placeId,
            fields: ["formatted_address", "geometry", "name", "address_components"],
            sessionToken: this._session
          },
          callback
        );
      }).catch(() => callback(null, "ERROR"));
    }
    destroy() {
      var _a, _b;
      this._requestGen++;
      (_a = this.input) == null ? void 0 : _a.removeEventListener("input", this._onInput);
      (_b = this.input) == null ? void 0 : _b.removeEventListener("keydown", this._onKeydown);
      document.removeEventListener("click", this._onDocClick, true);
      this.closeDropdown();
      this._ac = null;
      this._places = null;
      this._session = null;
    }
  };

  // assets/skipp-location-modal.js
  var DISTANCE_WARN_MIN_KM = 0.5;
  var CITY_PRESET_LOCATIONS = {
    bangalore: {
      city: "bangalore",
      lat: 12.9716,
      lng: 77.5946,
      label: "Bengaluru, Karnataka, India"
    },
    mumbai: {
      city: "mumbai",
      lat: 19.076,
      lng: 72.8777,
      label: "Mumbai, Maharashtra, India"
    }
  };
  var initedRoots = /* @__PURE__ */ new WeakSet();
  var boundEscapeHandler = null;
  function portalSkippLocationModalToBody(root) {
    if (!root || !document.body) return;
    try {
      if (root.parentElement === document.body) return;
      document.body.appendChild(root);
    } catch (e) {
    }
  }
  function dedupeEnhancedLocationModals() {
    const list = Array.from(document.querySelectorAll("#enhanced-location-modal"));
    if (list.length <= 1) return list[0] || null;
    const inSection = list.filter((el) => el.closest('[id^="shopify-section-"]'));
    const keeper = inSection.length ? inSection[inSection.length - 1] : list[list.length - 1];
    list.forEach((el) => {
      if (el !== keeper) el.remove();
    });
    return keeper;
  }
  async function searchOpenMeteoGeocoding(q) {
    if (!q || q.length < 2) return [];
    const url = `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(q)}&count=15&language=en&format=json`;
    const res = await fetch(url, {
      headers: { Accept: "application/json" }
    });
    if (!res.ok) return [];
    const data = await res.json();
    const rows = Array.isArray(data == null ? void 0 : data.results) ? data.results : [];
    const inIndia = rows.filter((r) => (r.country_code || "").toUpperCase() === "IN");
    const picks = (inIndia.length ? inIndia : rows).slice(0, 8);
    return picks.map((r) => {
      const name = cleanText(String(r.name || q)) || String(q).trim() || "Location";
      const admin = [r.admin1, r.admin2, r.country].filter(Boolean).join(", ");
      const secondary = cleanText(admin) || "";
      const lat = Number(r.latitude);
      const lng = Number(r.longitude);
      return {
        primary: name,
        secondary,
        lat: Number.isFinite(lat) ? lat : NaN,
        lng: Number.isFinite(lng) ? lng : NaN,
        postcode: null
      };
    }).filter((x) => Number.isFinite(x.lat) && Number.isFinite(x.lng));
  }
  async function searchAreaSuggestions(q) {
    let out = await searchOpenMeteoGeocoding(q);
    if (out.length) return out;
    out = await searchNominatim(q);
    return out;
  }
  async function searchNominatim(q) {
    if (!q || q.length < 2) return [];
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(q)}&limit=6&addressdetails=1&countrycodes=in&accept-language=en`;
    const res = await fetch(url, {
      headers: { Accept: "application/json", "Accept-Language": "en" }
    });
    if (!res.ok) return [];
    const rows = await res.json();
    return (rows || []).map((r) => {
      var _a;
      const addr = r.address || {};
      const postcode = addr.postcode ? String(addr.postcode).trim() : null;
      const primaryRaw = ((_a = r.display_name) == null ? void 0 : _a.split(",")[0]) || r.name || q;
      return {
        primary: cleanText(String(primaryRaw)) || String(primaryRaw).trim() || "Location",
        secondary: cleanText(String(r.display_name || "")) || "",
        lat: parseFloat(r.lat),
        lng: parseFloat(r.lon),
        postcode
      };
    });
  }
  function formatModalPrimaryLine(hasCity, deliveryText) {
    if (!hasCity) return browsingLocationTeaser(deliveryText);
    return (deliveryText || "30 - 90 mins").trim();
  }
  function refreshModalSummary(primaryEl, warnEl, expressText, nextDayText) {
    if (!primaryEl) return;
    const sel = getUserLocation();
    const hasCity = Boolean(sel.city);
    primaryEl.textContent = hasCity ? getDeliveryTimeLabel(sel.city, expressText, nextDayText) : formatModalPrimaryLine(false, expressText);
    if (!warnEl) return;
    const km = getDistanceKmIfAvailable();
    const away = km != null && km >= DISTANCE_WARN_MIN_KM && hasCity;
    if (away) {
      warnEl.textContent = `It is ${km} km away from your current location.`;
      warnEl.hidden = false;
    } else {
      warnEl.textContent = "";
      warnEl.hidden = true;
    }
  }
  function refreshHeaderPills(expressText, nextDayText) {
    if (typeof window.skippRefreshHeaderLocationPills === "function") {
      window.skippRefreshHeaderLocationPills();
    }
    const texts = document.querySelectorAll(".modern-header__location-text");
    const loc = getUserLocation();
    let eta = loc.city ? getDeliveryTimeLabel(loc.city, expressText, nextDayText) : "";
    if (!eta && loc.deliveryTime && String(loc.deliveryTime).trim()) {
      eta = String(loc.deliveryTime).trim();
    }
    let line;
    if (loc.city) {
      const parts = [];
      if (loc.pincode) parts.push(loc.pincode);
      parts.push(getCityDisplayLabel(loc.city));
      if (eta) parts.push(eta);
      line = parts.join(" \xB7 ");
    } else {
      line = formatModalPrimaryLine(false, expressText);
    }
    texts.forEach((n) => {
      n.textContent = line;
    });
  }
  function initSkippLocationModal(root) {
    if (!root || initedRoots.has(root)) return;
    initedRoots.add(root);
    let apiKey = (root.dataset.mapsKey || "").trim();
    if (!apiKey && typeof window !== "undefined" && window.__SKIPP_GOOGLE_MAPS_KEY__) {
      apiKey = String(window.__SKIPP_GOOGLE_MAPS_KEY__ || "").trim();
    }
    const expressDeliveryText = (root.dataset.deliveryText || "30 - 90 mins").trim();
    const nextDayText = (root.dataset.nextDayText || "Next day delivery").trim();
    const backdrop = root.querySelector("[data-skipp-loc-backdrop]");
    const btnOtherCity = root.querySelector("[data-skipp-loc-other-city]");
    const input = root.querySelector("[data-skipp-loc-search]");
    const list = root.querySelector("[data-skipp-loc-suggestions]");
    const btnGpsH = root.querySelector("[data-skipp-loc-browser-gps]");
    const primaryEl = root.querySelector("[data-skipp-loc-delivery-line]");
    const warnEl = root.querySelector("[data-skipp-loc-distance-warn]");
    const statusEl = root.querySelector("[data-skipp-loc-status]");
    let placesAutocomplete = null;
    let enforceMode = false;
    portalSkippLocationModalToBody(root);
    function syncEnforceChrome() {
      root.classList.toggle("skipp-loc-modal--enforce", enforceMode);
      const skip = root.querySelector("[data-skipp-loc-skip]");
      const closeBtn = root.querySelector("[data-skipp-loc-close]");
      if (skip) skip.hidden = enforceMode;
      if (btnOtherCity) btnOtherCity.hidden = enforceMode;
      if (closeBtn) closeBtn.hidden = enforceMode;
    }
    function afterLocationCommitted() {
      markLocationConfirmed();
      enforceMode = false;
      syncEnforceChrome();
    }
    function showStatus(msg, kind) {
      if (!statusEl) return;
      statusEl.textContent = msg || "";
      statusEl.classList.remove("is-error", "is-info");
      if (!msg) return;
      statusEl.classList.add(kind === "error" ? "is-error" : "is-info");
    }
    function hideStatus() {
      if (statusEl) {
        statusEl.textContent = "";
        statusEl.classList.remove("is-error", "is-info");
      }
    }
    function open() {
      portalSkippLocationModalToBody(root);
      root.classList.add("is-open");
      root.style.display = "flex";
      root.style.pointerEvents = "auto";
      root.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      syncEnforceChrome();
      hideStatus();
      refreshModalSummary(primaryEl, warnEl, expressDeliveryText, nextDayText);
      setTimeout(() => input == null ? void 0 : input.focus(), 100);
    }
    function close() {
      enforceMode = false;
      syncEnforceChrome();
      root.classList.remove("is-open");
      root.style.display = "none";
      root.style.pointerEvents = "";
      root.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      placesAutocomplete == null ? void 0 : placesAutocomplete.closeDropdown();
    }
    function applyCityPreset(keyRaw) {
      const key = String(keyRaw || "").trim().toLowerCase();
      const preset = CITY_PRESET_LOCATIONS[key];
      if (!preset) return;
      const dt = getDeliveryTimeLabel(preset.city, expressDeliveryText, nextDayText);
      setUserLocation(
        {
          city: preset.city,
          lat: preset.lat,
          lng: preset.lng,
          label: preset.label,
          pincode: null,
          deliveryTime: dt
        },
        { manual: true, source: "manual" }
      );
      if (input) input.value = preset.label;
      afterLocationCommitted();
      refreshModalSummary(primaryEl, warnEl, expressDeliveryText, nextDayText);
      refreshHeaderPills(expressDeliveryText, nextDayText);
      close();
    }
    function handleBrowseNeutralCatalog(ev) {
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      try {
        clearDeliverableUserLocation();
      } catch (e) {
      }
      try {
        markLocationSkipped();
      } catch (e) {
      }
      close();
      try {
        document.dispatchEvent(
          new CustomEvent("skipp:catalog-context-changed", { detail: { reason: "browse-later" } })
        );
      } catch (e) {
      }
      if (typeof window.skippRefreshHeaderLocationPills === "function") {
        window.skippRefreshHeaderLocationPills();
      }
    }
    root.addEventListener("click", (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest("[data-skipp-loc-close]")) {
        if (enforceMode && !isLocationEnforcementSatisfied()) {
          handleBrowseNeutralCatalog(e);
          return;
        }
        if (getLocationSetPreference() === null) {
          markLocationSkipped();
        }
        close();
        return;
      }
      if (t.closest("[data-skipp-loc-skip]") || t.closest("[data-skipp-loc-other-city]")) {
        handleBrowseNeutralCatalog(e);
        return;
      }
      const presetBtn = t.closest("[data-skipp-loc-city-preset]");
      if (presetBtn && presetBtn instanceof HTMLElement) {
        const val = presetBtn.dataset.skippLocCityPreset || presetBtn.getAttribute("data-skipp-loc-city-preset");
        if (val) applyCityPreset(val);
      }
    });
    if (backdrop) {
      backdrop.addEventListener("click", (e) => {
        if (e.target !== backdrop) return;
        if (enforceMode) return;
        if (getLocationSetPreference() === null) {
          markLocationSkipped();
        }
        close();
      });
    }
    function applyNominatimSelection(item) {
      const pcDigits = String(item.postcode || "").replace(/\D/g, "") || null;
      const rawCity = item.primary || item.city || "Location";
      const cityClean = cleanText(String(rawCity)) || "Location";
      const city = getCityFromPincode(pcDigits) || cityClean;
      const lat = item.lat;
      const lng = item.lng;
      const pincode = pcDigits;
      const labelClean = cleanText(String(item.secondary || item.label || "")) || city;
      const dt = getDeliveryTimeLabel(city, expressDeliveryText, nextDayText);
      if (lat != null && lng != null && Number.isFinite(lat) && Number.isFinite(lng)) {
        setUserLocation(
          {
            city,
            lat,
            lng,
            label: labelClean,
            pincode,
            deliveryTime: dt
          },
          { manual: true, source: "manual" }
        );
      } else {
        setUserLocation(
          {
            city,
            lat: null,
            lng: null,
            label: labelClean,
            pincode,
            deliveryTime: dt
          },
          { manual: true, source: "manual" }
        );
      }
      if (input) input.value = labelClean || cleanText(String(item.primary || "")) || city;
      afterLocationCommitted();
      refreshModalSummary(primaryEl, warnEl, expressDeliveryText, nextDayText);
      refreshHeaderPills(expressDeliveryText, nextDayText);
      close();
    }
    function applyGooglePlace(place, primary, secondary) {
      var _a;
      const sel = placeDetailsToSelection(place, primary);
      const pincode = sel.pincode;
      const city = sel.city || cleanText(String(primary || "")) || "Location";
      const secClean = cleanText(String(secondary || ""));
      const displayLabel = sel.full_address || [sel.name, secClean].filter(Boolean).join(", ") || cleanText(String(primary || ""));
      if (!((_a = place == null ? void 0 : place.geometry) == null ? void 0 : _a.location)) {
        setUserLocation(
          {
            city,
            lat: null,
            lng: null,
            label: displayLabel,
            name: sel.name,
            full_address: sel.full_address || null,
            pincode,
            deliveryTime: getDeliveryTimeLabel(city, expressDeliveryText, nextDayText)
          },
          { manual: true, source: "manual" }
        );
        afterLocationCommitted();
        refreshHeaderPills(expressDeliveryText, nextDayText);
        close();
        return;
      }
      setUserLocation(
        {
          city,
          lat: sel.lat,
          lng: sel.lng,
          label: displayLabel,
          name: sel.name,
          full_address: sel.full_address || null,
          pincode,
          deliveryTime: getDeliveryTimeLabel(city, expressDeliveryText, nextDayText)
        },
        { manual: true, source: "manual" }
      );
      afterLocationCommitted();
      placesAutocomplete == null ? void 0 : placesAutocomplete.refreshSession();
      if (input) input.value = sel.full_address || sel.name || cleanText(String(primary || ""));
      refreshModalSummary(primaryEl, warnEl, expressDeliveryText, nextDayText);
      refreshHeaderPills(expressDeliveryText, nextDayText);
      close();
    }
    window.openEnhancedLocationModal = function(_opts) {
      enforceMode = false;
      syncEnforceChrome();
      open();
    };
    window.openSimpleLocationModal = window.openEnhancedLocationModal;
    window.openFixedLocationModal = window.openEnhancedLocationModal;
    window.emergencyOpenModal = function(opts) {
      window.openEnhancedLocationModal(opts);
    };
    window.__skippOnLocationSkip = handleBrowseNeutralCatalog;
    window.__skippPortalLocationModalToBody = () => portalSkippLocationModalToBody(root);
    if (boundEscapeHandler) {
      document.removeEventListener("keydown", boundEscapeHandler);
    }
    boundEscapeHandler = (e) => {
      if (e.key !== "Escape") return;
      if (!root.classList.contains("is-open")) return;
      if (enforceMode && !isLocationEnforcementSatisfied()) {
        handleBrowseNeutralCatalog(null);
        return;
      }
      if (getLocationSetPreference() === null) {
        markLocationSkipped();
      }
      close();
    };
    document.addEventListener("keydown", boundEscapeHandler);
    document.addEventListener("skipp:user-location-changed", () => {
      refreshModalSummary(primaryEl, warnEl, expressDeliveryText, nextDayText);
      refreshHeaderPills(expressDeliveryText, nextDayText);
    });
    refreshHeaderPills(expressDeliveryText, nextDayText);
    refreshModalSummary(primaryEl, warnEl, expressDeliveryText, nextDayText);
    if (input && list) {
      try {
        placesAutocomplete = new SkippPlacesAutocomplete({
          apiKey,
          input,
          listContainer: list,
          debounceMs: 300,
          minChars: 2,
          country: "in",
          listVisibleClass: "is-visible",
          onSuggestions: (items) => {
            const q = (input.value || "").trim();
            if (q.length < 2) {
              hideStatus();
              return;
            }
            if (!items.length) {
              showStatus(
                "No search results. Use Bengaluru/Mumbai, GPS, or add a Google Maps API key (Theme settings \u2192 Skipp / Header).",
                "info"
              );
            } else {
              hideStatus();
            }
          },
          fallbackSearch: async (q) => {
            const rows = await searchAreaSuggestions(q);
            return rows.map((r) => ({
              primary: r.primary,
              secondary: r.secondary,
              lat: r.lat,
              lng: r.lng,
              postcode: r.postcode
            }));
          },
          onSelect: (item) => {
            if (!item) return;
            if (item.placeId) {
              placesAutocomplete.getPlaceDetails(item.placeId, (place, status) => {
                if (status !== "OK" || !place) {
                  applyNominatimSelection({
                    primary: item.primary,
                    secondary: item.secondary,
                    lat: null,
                    lng: null,
                    postcode: item.postcode || null
                  });
                  return;
                }
                applyGooglePlace(place, item.primary, item.secondary);
              });
              return;
            }
            applyNominatimSelection(item);
          }
        });
      } catch (err) {
        console.warn("[Skipp] Location search (Places) failed to initialize. Skip and GPS still work.", err);
      }
    }
    if (btnGpsH) {
      btnGpsH.addEventListener("click", async () => {
        if (!navigator.geolocation) {
          showStatus("Geolocation is not supported in this browser.", "error");
          return;
        }
        btnGpsH.disabled = true;
        hideStatus();
        try {
          const r = await promptBrowserGeolocationAndApplyLocation({
            expressDeliveryText,
            nextDayDeliveryText: nextDayText,
            force: true
          });
          if (r.ok) {
            afterLocationCommitted();
            refreshModalSummary(primaryEl, warnEl, expressDeliveryText, nextDayText);
            refreshHeaderPills(expressDeliveryText, nextDayText);
            close();
            return;
          }
          try {
            await setUserLocationFromIP({
              expressDeliveryText,
              nextDayDeliveryText: nextDayText
            });
            afterLocationCommitted();
            refreshHeaderPills(expressDeliveryText, nextDayText);
            showStatus("Using approximate location (network).", "info");
            setTimeout(close, 400);
          } catch (e) {
            showStatus(
              r.reason === "denied" ? "Location permission denied. Try search or check browser settings." : "Could not detect location.",
              "error"
            );
          }
        } finally {
          btnGpsH.disabled = false;
        }
      });
    }
  }

  // assets/skipp-location-modal-entry.js
  function migrateLegacyPreference() {
    var _a;
    if (getLocationSetPreference() !== null) return;
    const u = getUserLocation();
    if ((_a = u == null ? void 0 : u.city) == null ? void 0 : _a.trim()) markLocationConfirmed();
  }
  function bootModalFromDom() {
    const el = dedupeEnhancedLocationModals();
    migrateLegacyPreference();
    if (!el) return;
    try {
      initSkippLocationModal(el);
    } catch (err) {
      console.error("[Skipp] Location modal init failed. Inline fallback opener still works.", err);
    }
  }
  function skippEnsureModalPorted() {
    const el = document.getElementById("enhanced-location-modal");
    if (el) portalSkippLocationModalToBody(el);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootModalFromDom);
  } else {
    bootModalFromDom();
  }
  document.addEventListener("shopify:section:load", () => {
    requestAnimationFrame(() => {
      skippEnsureModalPorted();
      bootModalFromDom();
    });
  });
  window.addEventListener("pageshow", () => {
    skippEnsureModalPorted();
  });
  function skippAllowAutomaticLocationPromptThisPage() {
    var _a;
    try {
      if (window.__SKIPP_ALLOW_AUTO_LOCATION_PROMPT__ !== true) return false;
      const path = (window.location.pathname || "").toLowerCase();
      if (path.includes("/cart") || path.includes("/checkout")) return false;
      if (path.includes("/products/")) return false;
      if ((_a = document.body) == null ? void 0 : _a.classList.contains("template-product")) return false;
      return true;
    } catch (e) {
      return false;
    }
  }
  function shouldAutoOpenLocationModal() {
    try {
      if (!skippAllowAutomaticLocationPromptThisPage()) return false;
      if (getLocationSetPreference() !== null) return false;
      if (hasHomeLocationPromptBeenShown()) return false;
      const u = getUserLocation();
      if (u && String(u.city || "").trim()) return false;
      return true;
    } catch (e) {
      return false;
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(async () => {
      var _a, _b;
      try {
        if (!skippAllowAutomaticLocationPromptThisPage()) return;
        if (getLocationSetPreference() === "true") return;
        const existingLoc = getUserLocation();
        if (existingLoc && String(existingLoc.city || "").trim()) return;
        if (hasBrowserGeoAutoBeenAttempted()) return;
        const modal = document.getElementById("enhanced-location-modal");
        let r = { ok: false };
        try {
          r = await promptBrowserGeolocationAndApplyLocation({
            expressDeliveryText: (_a = modal == null ? void 0 : modal.dataset) == null ? void 0 : _a.deliveryText,
            nextDayDeliveryText: (_b = modal == null ? void 0 : modal.dataset) == null ? void 0 : _b.nextDayText
          });
        } finally {
          markBrowserGeoAutoAttempted();
        }
        if (r.ok) markLocationConfirmed();
      } catch (e) {
        try {
          markBrowserGeoAutoAttempted();
        } catch (e2) {
        }
      }
    }, 120);
    setTimeout(() => {
      if (!shouldAutoOpenLocationModal()) return;
      if (typeof window.openEnhancedLocationModal !== "function") return;
      markHomeLocationPromptShown();
      window.openEnhancedLocationModal({});
    }, 450);
    setTimeout(async () => {
      var _a, _b;
      try {
        if (typeof window.SkippUserLocation === "undefined") return;
        if (getLocationSetPreference() !== "true") return;
        const u = window.SkippUserLocation.getUserLocation();
        if (u && u.city) return;
        if (sessionStorage.getItem("skipp_loc_ip_bootstrap_v2")) return;
        sessionStorage.setItem("skipp_loc_ip_bootstrap_v2", "1");
        const modal = document.getElementById("enhanced-location-modal");
        await window.SkippUserLocation.setUserLocationFromIP({
          expressDeliveryText: (_a = modal == null ? void 0 : modal.dataset) == null ? void 0 : _a.deliveryText,
          nextDayDeliveryText: (_b = modal == null ? void 0 : modal.dataset) == null ? void 0 : _b.nextDayText
        });
      } catch (e) {
      }
    }, 1400);
  });
})();
